import { addMinutes, startOfDay } from 'date-fns'

import { formatDateOnly, formatTimeOnly } from '../date'

interface FormatDeliveryTimeSlotParams {
  date: number
  startMinutes: number
  endMinutes: number
  deliverySlotLength: number
}

export const formatDeliveryTimeSlot = ({
  date,
  startMinutes,
  endMinutes,
  deliverySlotLength,
}: FormatDeliveryTimeSlotParams): string => {
  const finishMinutes = Math.min(startMinutes + deliverySlotLength * 60, endMinutes)

  const baseDate = startOfDay(new Date(date))
  const startTime = formatTimeOnly(addMinutes(baseDate, startMinutes)).toUpperCase()
  const endTime = formatTimeOnly(addMinutes(baseDate, finishMinutes)).toUpperCase()

  return `${formatDateOnly(date)} ${startTime}-${endTime}`
}
